import { domQuerySelector } from 'pf-frontend-common/src/helper/dom/query-selector';

import { ContentGroupStrategyTabFactory } from 'common/module/content-group/strategy/tab.factory';
import { AbTestService } from 'common/service/ab-test/service';
import { FooterService } from 'common/service/footer/service';
import { HeaderService } from 'common/service/header/service';
import { LanguageSelectorService } from 'common/service/language-selector/service';
import { UserAuthenticationService } from 'common/service/user-authentication/service';
import { TermsAndConditionsPageViewFactory } from 'desktop/module/terms-and-conditions/page/view.factory';
import { UserAvatarComponent } from 'desktop/module/user/avatar/component';

AbTestService().initialize();

// Common services
HeaderService()
  .setComponents({
    UserAvatarComponent,
  })
  .render();
UserAuthenticationService();
FooterService();

LanguageSelectorService();

const element = domQuerySelector(document, '[data-qs="terms-and-conditions"]');
const strategy = ContentGroupStrategyTabFactory();
strategy.initialize({ serializeToUrl: true });

const page = TermsAndConditionsPageViewFactory();

page.initialize({
  element,
  subview: {
    tab: {
      viewOptions: {
        element: domQuerySelector(element, '[data-qs="tab"]'),
        strategy,
      },
    },
  },
});

page.render();
